import { c as _c } from "react/compiler-runtime";
import { useDesignContext } from '@systemeio/digital-store-shared';
import { ColorPicker } from '@systemeio/ui';
import React from 'react';
import { FieldLabel } from 'shared/components/form/field-label';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export function StoreThemeColorPicker() {
  const $ = _c(26);
  const {
    t
  } = useLocoTranslation();
  const {
    state,
    setState
  } = useDesignContext();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.store.theme.colors");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <FieldLabel label={t0} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== setState) {
    t2 = primaryColor => setState(prev => ({
      ...prev,
      primaryColor
    }));
    $[4] = setState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== state.primaryColor || $[7] !== t2) {
    t3 = <ColorPicker popoverClassName="z-50" color={state.primaryColor} onChange={t2} />;
    $[6] = state.primaryColor;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== setState) {
    t4 = secondaryColor => setState(prev_0 => ({
      ...prev_0,
      secondaryColor
    }));
    $[9] = setState;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== state.secondaryColor || $[12] !== t4) {
    t5 = <ColorPicker popoverClassName="z-50" color={state.secondaryColor} onChange={t4} />;
    $[11] = state.secondaryColor;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== setState) {
    t6 = tertiaryColor => setState(prev_1 => ({
      ...prev_1,
      tertiaryColor
    }));
    $[14] = setState;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== state.tertiaryColor || $[17] !== t6) {
    t7 = <ColorPicker popoverClassName="z-50" color={state.tertiaryColor} onChange={t6} />;
    $[16] = state.tertiaryColor;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t5 || $[21] !== t7) {
    t8 = <div className="flex gap-3">{t3}{t5}{t7}</div>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t1 || $[24] !== t8) {
    t9 = <div className="flex flex-col gap-1">{t1}{t8}</div>;
    $[23] = t1;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}